import { useMutation, useQueryClient } from '@tanstack/react-query';

import { approveProjectRequest } from '@/api/v4/request-project.api';
import { QueryKey } from '@/config/query-client';
import { useNavigateTo } from '@/routes/hooks/use-navigate-to';
import { notify } from '@/ui/snackbar/notify';
import { useTranslation } from 'react-i18next';

export const useApproveProjectRequest = () => {
  const queryClient = useQueryClient();
  const navigateTo = useNavigateTo();
  const { t } = useTranslation('request-project');

  return useMutation({
    mutationFn: approveProjectRequest,
    onSuccess: async response => {
      await queryClient.invalidateQueries({
        queryKey: [QueryKey.PendingProjectRequests],
      });
      await queryClient.invalidateQueries({
        queryKey: [QueryKey.PendingProjectRequestsCount],
      });
      await queryClient.invalidateQueries({ queryKey: [QueryKey.Projects] });
      await queryClient.invalidateQueries({
        queryKey: [QueryKey.LastActivities],
      });
      await queryClient.invalidateQueries({
        queryKey: [QueryKey.LastActivitiesCount],
      });

      navigateTo.project({ projectId: response.projectId });

      notify({
        message: t`approveModal.success`,
      });
    },
    onError: error => {
      console.error('Failed to approve project request:', error);

      notify({
        message: t`approveModal.error`,
      });
    },
  });
};
